import React, {ReactNode} from 'react';
import styles from './PageHeader.module.css';
import {BackButton} from "../buttons/BackButton";
import {BreadcrumbItem, NewBreadcrumbs} from "../NewBreadcrumbs/NewBreadcrumbs";

interface PageHeaderProps {
    title?: string;
    buttons: ReactNode;
    isAdmin: boolean;
    enabledBreadcrumbs?: boolean
    enabledBackBtn?: boolean
    breadcrumbsItems?: BreadcrumbItem[]
}

export const PageHeader: React.FC<PageHeaderProps> = ({
                                                          title,
                                                          buttons,
                                                          isAdmin,
                                                          enabledBreadcrumbs = false,
                                                          enabledBackBtn = false,
                                                          breadcrumbsItems = []
                                                      }) => {

    return (

        <div className={styles.header}>
            {enabledBackBtn && (
                <BackButton className={styles.backBtn}/>
            )}
            {enabledBreadcrumbs && (
                <NewBreadcrumbs items={breadcrumbsItems}
                                isAdmin={isAdmin}
                />
            )}
            <div className={styles.headerTop}>
                {title && (
                    <h1 className={styles.title}>{title}</h1>
                )}
                <div className={styles.buttonsContainer}>
                    {buttons}
                </div>
            </div>

        </div>

    );
};
